export const DefaultIconNodeDisplay = {
  drawingType: 'ICON' as DiagramDrawingType,
  x1: -31,
  y1: 26,
};
